import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const AdminGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, roles, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  const hasAccess = roles.some(r => ['admin', 'editor', 'translator', 'leads_manager'].includes(r));
  if (!hasAccess) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

export default AdminGuard;
